import { memo, useMemo, useCallback, useEffect, useState, createRef } from 'react';
import { View, StyleSheet, Text, Image, ScrollView } from 'react-native';
import { I18n, Utils, FormInput, AddButton, Panel, TextInputPlain } from '../../components';
import { THEME, __WEB__, COLOR, FONT } from '../../../constants/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getCurrentEmployer } from '../../../selectors/entities';
import {
  saveEmployerSetupData,
  deleteEmployerSetupData,
  resetStatus,
} from '../../employer/actions';

import EditableList from './editable_list';

export default memo(
  connect(
    function (state, ownProps) {
      const employer = getCurrentEmployer(state);
      return {
        employer,
        items: state.screens.employer.setupData?.medicalServices?.slice()?.sort(function (a, b) {
          return a.name < b.name ? -1 : 1;
        }),
      };
    },
    function (dispatch) {
      return {
        actions: bindActionCreators(
          { saveEmployerSetupData, deleteEmployerSetupData, resetStatus },
          dispatch
        ),
      };
    }
  )(function (props) {
    function handleSave(names) {
      props.actions.saveEmployerSetupData(props.employer.employerId, 'medicalServices', { names });
    }
    function doDelete(val) {
      props.actions.deleteEmployerSetupData(
        props.employer.employerId,
        'medicalServices',
        val.employer_medical_service_id
      );
    }
    function handleDelete(val) {
      const confirmationOpts = {
        title: 'Delete this item?',
        confirm: 'Yes, Delete',
        onConfirmed: () => {
          doDelete(val);
        },
      };
      props.onConfirmationOpts(confirmationOpts);
    }
    function handleAddPress() {
      props.actions.resetStatus();
    }

    function itemKey(item) {
      return item.employer_medical_service_id;
    }
    return (
      <EditableList
        title="Medical Service"
        items={props.items}
        keyFunc={itemKey}
        collapsable={props.collapsable}
        containerStyle={props.containerStyle}
        onSave={handleSave}
        onDelete={handleDelete}
        onAddPress={handleAddPress}
        canEdit={props.canEdit}
        placeholderText="Ex: Pediatrics, Radiology, Orthopedic Surgery, ..."
      />
    );
  })
);
